import { z } from "zod";
import { ENTITY_NAMES } from "@miplatform/constants";

export const configInspectionTemplateSchema = z.object({
  name: z
    .string()
    .min(1, `${ENTITY_NAMES.INSPECTION_TEMPLATE} Name is required`),
  abbreviation: z
    .string()
    .min(1, "Abbreviation is required")
    .max(3, "Abbreviation must be at most 3 characters"),
  description: z.string().optional(),
  color: z.string().min(1, "Color is required"),
  allowAiRedTag: z.boolean().optional(),
  orderTemplates: z.array(z.string()).optional(),
  rescheduleReasons: z.array(z.string()).optional(),
});
